import { CellTypes } from '../../pricingModelTable';

export const getCellSign = (cellType: CellTypes) => {
  switch (cellType) {
    case CellTypes.PERCENTAGE:
      return '%';
    default:
      return '';
  }
};
